import { useClickOutside } from '@lib/hooks'
import { useProjectLegacyActions } from '@store/migrationActions/useProjectLegacyActions'
import {
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import type React from 'react'
import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

export const useNameInput = (
  name: string,
  showInput: boolean,
  onHideInput: () => void
) => {
  const dispatch = useDispatch()

  const [value, setValue] = useState(name)
  const [width, setWidth] = useState(138)
  const spanRef = useRef<HTMLSpanElement>(null)

  const { renameProject } = useProjectLegacyActions()

  const clickOutside = useClickOutside<HTMLDivElement>(showInput, () => {
    onHideInput()
    handleSubmit()
  })

  useEffect(() => {
    if (spanRef.current) {
      setWidth(spanRef.current.offsetWidth)
    }
  }, [value])

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
  }

  const handleSubmit = () => {
    if (value.trim().length === 0) {
      dispatch(
        notificationActionCreators.setNotification({
          type: NotificationType.RENAME_ERROR,
        })
      )

      setTimeout(() => {
        dispatch(
          notificationActionCreators.setClearNotification({
            toastContainerId: 'main',
          })
        )
      }, 3000)
    }

    if (value !== name && value.trim().length > 0) {
      renameProject({ title: value })

      onHideInput()
      sendGtmEvent(GtmTriggerName.PROJECT_RENAME)
    }
  }

  return {
    value,
    clickOutside,
    spanRef,
    width,
    handleOnChange,
    handleSubmit,
  }
}
